import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import {LabelForm, LabelNota } from '../componentes_generales/componentes_formulario/labels/';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import styled from 'styled-components';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { cargar_DevolucionElectronica, cargar_DevolucionesElectronicas } from '../../actions/ventas/act_ven05';
import { completar_String, formatearNumeroDecimal, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarCampoString, validarPermisoAcceso, validarFechaTransaccionSeleccionada, validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import PuntoFacturacion from '../ventas/puntoFacturacion';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { multiplicarDecimales } from '../../funciones_globales/operacionesMatematicas';
import global_axios from '../../funciones_globales/interaccionapi';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import DocumentosGeneradosPorImprimir from './docsGeneradPorImprimir';
import { setDocumentosPorImprimir } from '../../actions/ventas/act_ven02';

const LabelTotales = styled.label`
  display: inline-block;
  font-size: 10px;
  color: green;
`;

const LabelValorTotales = styled.label`
  display: inline-block;
  font-size: 9px;
  font-weight: bold;
  align-text: right;
`;

const ContenedorModal = styled.div`
  margin-top: 20px;
  height: 400px;
  width: 770px;
`;

class FormVen05 extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {
      operacion: 'M',
      detDevolucion: [],
      notasCredito: [],
      devElectronicasPend: [],
      devolucionId: '',
      cliente_Sel: '',
      vendedor_Sel: '',
      observacion: '',
      aplicaGarantia: false,
      fechaDevolucionElect: null,
      fechaEmisionNCredito: null,
      totalDevolucion: parseFloat(0),
      isVisibleModalDevElect: false,      
      isVisibleCompGenPorImp: false,
      columnsDefGridDevolucion: [
        { header: "No.",
          field: "Secuencia",
          width: 45,
          type: "string"
        },
        { header: "Cód. Art.",
          field: "Articulo",
          width: 105,
          type: "string"
        },
        { header: "Descripción",
          field: "Descripcion",
          width: 340,
          type: "string"
        },
        { header: "Motivo",
          field: "Motivo",
          width: 181,
          type: "string"
        },
        { header: "Cant. Devuelta",
          field: "CantDevuelta",
          width: 110,
          type: "num_entero"
        },
        { header: "Cant. Recibida",
          field: "CantRecibida",
          width: 110,
          type: "num_entero"
        },
        { header: "Cant. Verificada",
          field: "CantVerificada",
          width: 110,
          type: "num_entero"
        },
      ],
      columnsDefGridNotasCredito: [
        { header: "No.",
          field: "Secuencia",
          width: 45,
          type: "string"
        },
        { header: "Articulo",
          field: "Articulo",
          width: 60,
          type: "string"
        },
        { header: "Cant.",
          field: "Cantidad",
          width: 50,
          type: "num_entero"
        },
        { header: "Factura",
          field: "Factura",
          width: 135,
          type: "string"
        },   
        { header: "Motivo",
          field: "Motivo",
          width: 60,
          type: "string"
        },
        { header: "Subtotal",
          field: "Subtotal",
          width: 80,
          type: "num_decimal"
        },
        { header: "Dscto. Total",
          field: "DsctoTotal",
          width: 90,
          type: "num_decimal"
        },
        { header: "Dscto. Línea",
          field: "DsctoLinea",
          width: 90,
          type: "num_decimal"
        },
        { header: "Valor Iva",
          field: "ValorIva",
          width: 80,
          type: "num_decimal"
        },
        { header: "Total",
          field: "Total",
          width: 80,
          type: "num_decimal"
        },
        { header: "Descripción",
          field: "Descripcion",
          width: 300,
          type: "string"
        },        
      ],
      colsDefDevolPend: [
        { header: "No.",
          field: "NroDev",
          width: 40,
          type: "string",
          suppressFilter: true
        },        
        { header: "Devol. Elect.",
          field: "Devolucion",
          width: 110,
          type: "string"
        },
        { header: "Fecha",
          field: "Fecha",
          width: 100,
          type: "string"          
        },
        { header: "Cliente",
          field: "Cliente",
          width: 250,
          type: "string"
        },
        { header: "Vendedor/Recaudador",
          field: "Vendedor",
          width: 250,
          type: "string"
        },
      ]
    };

    this.gridDevolucionOptions = {
      enableColResize: true,
      enableSorting: true
    };

    this.gridNotasCreditoOptions = {
      enableColResize: true,
      enableSorting: true
    };

    this.gridDevPendOptions = {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,

      onRowDoubleClicked: (event)=>{
        this.setState({ devolucionId: event.data.Devolucion });
        this.getDevolucionElectronicaById();
        this.cambiarVisualizacionModalDevElect();
      }
    };
    
    this.onGridDevolucionReady = this.onGridDevolucionReady.bind(this);
    this.onGridNotasCreditoReady = this.onGridNotasCreditoReady.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.limpiar = this.limpiar.bind(this);
    this.getDevolucionElectronicaById = this.getDevolucionElectronicaById.bind(this);
    this.procesarDevolucion = this.procesarDevolucion.bind(this);
    this.cambiarVisualizacionModalDevElect = this.cambiarVisualizacionModalDevElect.bind(this);
  }
  
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  onGridDevolucionReady(params) {
    this.apiGridDevolucion = params.api;
    this.columnApiGridDevolucion = params.columnApi;
  }

  onGridNotasCreditoReady(params) {
    this.apiGridNotasCredito = params.api;
    this.columnApiGridNotasCredito = params.columnApi;
  }

  onGridDevolPendientesReady(params) {
    this.apiGridDevolPend = params.api;
    this.columnApiGridDevolPend = params.columnApi;
  }
  
  componentDidMount(){
    this.props.generar_LogAuditoriaIngresoForm('0405');
    try {
      let fechaProceso = getFechaProcesoPorModulo('04');
      this.setState({fechaEmisionNCredito: moment(fechaProceso, 'DD/MM/YYYY')});      
    } catch (error) {
      alert(`Ocurrió un error al generar la carga de parámetros necesarios de la pantalla. Error: ${error}`);
    }    
  }

  componentWillUnmount(){
    this.props.generar_LogAuditoriaSalidaForm('0405');
  }

  cambiarVisualizacionModalDevElect(){
    if (this.state.isVisibleModalDevElect===false){      
      this.props.cargar_DevolucionesElectronicas('O');
    }

    this.setState({ isVisibleModalDevElect: !this.state.isVisibleModalDevElect });
  }

  limpiar(){
    let fechaProceso = getFechaProcesoPorModulo('04');
    this.setState({      
      cliente_Sel: '',
      vendedor_Sel: '',      
      detDevolucion: [],
      notasCredito: [],
      devolucionId: '',      
      observacion: '',
      aplicaGarantia: false,
      fechaDevolucionElect: null,
      fechaEmisionNCredito: moment(fechaProceso, 'DD/MM/YYYY'),
      totalDevolucion: parseFloat(0),
      isVisibleModalDevElect: false
    });
  }

  getDevolucionElectronicaById(){    
    let idDevolucion = this.state.devolucionId;
    if (!validarCampoString(idDevolucion, 6)){
      alert('No ha especificado el No. de Devolución Electrónica correctamente.');
      return;
    }

    this.props.cargar_DevolucionElectronica(idDevolucion)
    .then(()=>{
      try{
        let detDevolucion = [];
        let devolucionElect = this.props.devolucionElectSel;
        let tieneGarantia = false;

        if (devolucionElect===null){
          alert('La Devolución Electrónica especificada no existe.');
          return;
        }

        if (devolucionElect.Status==='N' || devolucionElect.Status==='GT'){
          alert('La Devolución Electrónica No.: ' + idDevolucion + ' ya fue procesada.');
          return;
        }

        if (devolucionElect.Status!=='O'){
          alert('La Devolución Electrónica No.: ' + idDevolucion + ' no está lista para ser procesada.');
          return;
        }

        devolucionElect.detDevolucion.forEach((item, i)=>{
          detDevolucion.push({
            Secuencia: item.Secuencia,
            Articulo: item.art.Codigo,
            Descripcion: item.art.Nombre,
            Motivo: item.motivo.Codigo + ' - ' +  item.motivo.Descripcion,
            CantDevuelta: item.Cantidad,
            CantRecibida: item.Recibido,
            CantVerificada: item.CantidadReal
          });

          if ((item.MotivoReal===null?'':item.MotivoReal)===''){
            if (item.Motivo==='19'){
              tieneGarantia = true;
            }
          }else{
            if (item.MotivoReal==='19'){
              tieneGarantia = true;
            }
          }
        });

        let facturasParaNotasCred = [];
        let totalDevolucion = parseFloat(0);
        
        this.props.facturasPend.forEach((item, i)=>{
          let total = parseFloat(parseFloat(item.Total) + parseFloat(multiplicarDecimales(item.Total, parseFloat(item.PorcentajeIva)/100))).toFixed(2);
          totalDevolucion = parseFloat(parseFloat(totalDevolucion) +  parseFloat(total)).toFixed(2);

          facturasParaNotasCred.push({
            Secuencia: completar_String((i+1).toString(), '0', 3),
            Articulo: item.Articulo,
            Cantidad: item.Cantidad,
            IdFactura: item.IdFactura,
            Factura: item.Factura,
            Motivo: item.Motivo,
            Subtotal: item.Subtotal,
            DsctoTotal: parseFloat(parseFloat(item.Subtotal) - parseFloat(item.Total)),
            DsctoLinea: parseFloat(parseFloat(item.Subtotal) - parseFloat(item.Subtotaldescuento)),
            ValorIva: parseFloat(multiplicarDecimales(item.Total, parseFloat(item.PorcentajeIva)/100)).toFixed(2),
            Total: parseFloat(total),
            Descripcion: item.DescripMotivo
          });
        });

        this.setState({ detDevolucion, fechaDevolucionElect: moment(devolucionElect.Fecha, 'DD/MM/YYYY'),
                        cliente_Sel: devolucionElect.cli, vendedor_Sel: devolucionElect.vend[0],
                        observacion: devolucionElect.Observacion===null?'':devolucionElect.Observacion.toString().trim(),
                        notasCredito: facturasParaNotasCred, totalDevolucion, aplicaGarantia: tieneGarantia });
      }catch(error){
        alert('Ha ocurrido un error al cargar los datos de la Devolución Electrónica seleccionada.: ' + error);
      }
    });
  }

  procesarDevolucion(){
    let idDevolucion = this.state.devolucionId;

    if(!validarCampoString(idDevolucion, 6)){
      alert('La Devolución Electrónica especificada es inválida.');
      return;
    }

    let fechaEmisionNCredito = formatearFechaMoment_a_String(this.state.fechaEmisionNCredito);
    if (!validarFechaMomentEnFormatoString(fechaEmisionNCredito)){
      alert('La fecha de emisión de nota de crédito es inválida.');
      return;
    }

    let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
    if (!validPermiso.esValido){
      alert(validPermiso.msg);
      return;
    }

    let fechaProceso = getFechaProcesoPorModulo('04');
    if (this.props.permiteCambioFProceso==='S'){
      let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaEmisionNCredito, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
      
      if(!validFProceso.esValida){
        alert(validFProceso.msg);
        return;
      }
    }

    if (this.state.notasCredito.length===0){
      alert('No existen notas de crédito para procesar.');
      return;
    }   

    let devolucion = {  
      fechaEmision: fechaProceso,
      devolucionElect: idDevolucion,
      aplicaGarantia: this.state.aplicaGarantia,
      ptoFacturac: this.props.puntoFacturacionSel,
      observacion: this.state.observacion,
      usuario: getItemDatosSesion('usuario'),      
      facturas: []
    };

    /*En el grid de detalle de notas de credito a procesar constan los articulos y las facturas de las cuales se hará
    las devoluciones, sin embargo deberá enviarse a la api solo las distintas facturas y motivos. */
    
    let distintasFacturas = [];

    this.state.notasCredito.forEach(item=>{
      
      let existeFactyMotivo = false;

      for(let c=0; c<distintasFacturas.length; c++){
        let facturaMotivo = distintasFacturas[c];
        if(item.IdFactura===facturaMotivo.idFactura && item.Motivo===facturaMotivo.motivo){
          existeFactyMotivo = true;
          break;
        }
      }

      if(!existeFactyMotivo){
        distintasFacturas.push({
          idFactura: item.IdFactura,
          motivo: item.Motivo});
      }
      
    });
    
    devolucion.facturas = distintasFacturas;
    
    this.props.cambiar_VisualizacionLoading(true);

    global_axios({
      method: 'POST',
      url: '/devolucioneselectronicas',
      data: devolucion
    })
    .then((response)=> {
      this.props.cambiar_VisualizacionLoading(false);      

      let devolucionesAImprimir = [];
      response.data.devolucionesGen.forEach((devolucion, i) => {
        devolucionesAImprimir.push({
            Nro: (i+1),
            NroDocumento: devolucion,
            EstadoImp: 'POR IMPRIMIR'
        });
      });

      if (this.state.aplicaGarantia){
        alert('Esta Devolución Electrónica tiene artículos por garantía pendientes.');
      }

      this.props.setDocumentosPorImprimir(devolucionesAImprimir);
      this.setState({isVisibleCompGenPorImp: true});
      this.limpiar();
    })
    .catch((error)=> {
      this.props.cambiar_VisualizacionLoading(false);
      alert(error.response?error.response.data.msg:error.message);
    });    
  }

  render(){
    let devolElectronicas = [];    
    this.props.devolElectronicas.forEach((devolElect, i) =>{
      devolElectronicas.push({
        ...devolElect,
        NroDev: (i+1),
        Cliente: devolElect.cli.Codigo + ' - ' + devolElect.cli.Nombre,
        Vendedor: devolElect.vend===null?'':(devolElect.vend.Codigo + ' - ' + devolElect.vend.Nombre)
      });
    })

    return(
      <div>
        <ContenedorForm porc_ancho={76}>
          <HeaderForm>
            <TituloForm>Devolución Electrónica</TituloForm>
          </HeaderForm>
          <CuerpoForm>
              <Row>
                <ContainerCol className='col-sm-2'>
                  <LabelForm>Devolución Elect.:</LabelForm>
                  <InputSearch tipoInput='text' nombre='devolucionId' placeholder='Dev. Elect.' valor={this.state.devolucionId} func_CambiarValor={this.handleInputChange} 
                    func_BuscarValor={this.getDevolucionElectronicaById} func_OnFocus={()=>{this.limpiar();}}/>
                </ContainerCol>              
                <ContainerCol className='col-sm-2'>
                    <LabelForm>Fecha Dev. Elect:</LabelForm>
                    <PickerFecha fechaSeleccionada={this.state.fechaDevolucionElect} disabled={true}/>
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelForm>Cliente:</LabelForm>
                  <InputText name='cliente' placeholder='Cliente' disabled={true} value={this.state.cliente_Sel===''?'':(this.state.cliente_Sel.Codigo + ' - ' + this.state.cliente_Sel.Nombre)}/>
                </ContainerCol>
                <ContainerCol className='col-sm-4'>
                  <LabelForm>Vendedor/Recaudador:</LabelForm>
                  <InputText name='vendedor' placeholder='Vendedor' disabled={true} value={(this.state.vendedor_Sel==='' || this.state.vendedor_Sel===null)?'':(this.state.vendedor_Sel.Codigo + ' - ' + this.state.vendedor_Sel.Nombre)}/>
                </ContainerCol>
              </Row>
              <Row>
                <ContainerCol className='col-sm-2'>
                    <LabelForm>Fecha Emisión N/C.:</LabelForm>
                    <PickerFecha fechaSeleccionada={this.state.fechaEmisionNCredito} disabled={!(this.props.permiteCambioFProceso==='S')}
                      func_onChange={(fecha)=>{this.setState({fechaEmisionNCredito: fecha})}}/>
                </ContainerCol>
                <ContainerCol className='col-sm-2'>
                    <LabelForm>Pto. Facturación:</LabelForm>
                    <PuntoFacturacion/>
                </ContainerCol>
                <ContainerCol className='col-sm-8'>
                  <LabelForm>Observación:</LabelForm>
                  <InputText name='observacion' placeholder='Observación' value={this.state.observacion} onChange={this.handleInputChange}/>
                </ContainerCol>
              </Row>
              <Row className='pull-right'>
                <ContainerCol margen_arriba={5} className='col-sm-12'>
                  <Tooltip placement="left" overlay='Ver Devoluciones Electrónicas Pendientes de Procesar'>
                    <button type='button' className='btn btn-default btn-sm' onClick={this.cambiarVisualizacionModalDevElect}><i className='fa fa-download fa-lg'/> Importar Devoluciones Elect.</button>
                  </Tooltip>
                </ContainerCol>
              </Row>
              <Row>
                  <ContainerCol className='col-sm-12'>
                  <LabelForm>Detalle de Devolución Electrónica:</LabelForm>
                  <AgGridRender altura='150px' data={this.state.detDevolucion} columnas={this.state.columnsDefGridDevolucion}
                  gridOptions={this.gridDevolucionOptions} onGridReady={this.onGridDevolucionReady}/>
                  </ContainerCol>
              </Row>
              <Row>
                  <ContainerCol className='col-sm-12'>
                  <LabelForm>Notas de Crédito a generar:</LabelForm>
                  <AgGridRender altura='150px' data={this.state.notasCredito} columnas={this.state.columnsDefGridNotasCredito}
                  gridOptions={this.gridNotasCreditoOptions} onGridReady={this.onGridNotasCreditoReady}/>
                  </ContainerCol>
              </Row>
              <Row>
                <div className='col-sm-12'>
                  <LabelTotales>Total: </LabelTotales><LabelValorTotales>{formatearNumeroDecimal(this.state.totalDevolucion)}</LabelValorTotales>
                </div>
              </Row>
              <Row>          
                  <div className='col-sm-12'>
                    <div className='btn-group pull-right'>                    
                        <button type='button' className='btn btn-primary btn-sm' onClick={this.procesarDevolucion}><i className='fa fa-cogs fa-lg'/> Procesar</button>
                        <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>                    
                    </div>
                  </div>
              </Row>
          </CuerpoForm>
        </ContenedorForm>
        <ModalResponsive open={this.state.isVisibleModalDevElect} onClose={()=>{this.setState({isVisibleModalDevElect:false})}}>
          <ContenedorModal>
            <Row>
              <div className='col-sm-12'>
                <LabelForm>Devoluciones Electrónicas pendientes de procesar</LabelForm>
              </div>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <AgGridRender altura='320px' data={devolElectronicas} columnas={this.state.colsDefDevolPend}
                  gridOptions={this.gridDevPendOptions} onGridReady={this.onGridDevolPendientesReady}/>              
              </div>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <div className="btn-group pull-right">
                  <button type='button' className='btn btn-success btn-sm' onClick={()=> {this.props.cargar_DevolucionesElectronicas('O');}}><i className='fa fa-refresh fa-lg'></i> Actualizar</button>
                  <button type='button' className='btn btn-danger btn-sm' onClick={this.cambiarVisualizacionModalDevElect}><i className='fa fa-times-circle fa-lg'></i> Cerrar</button>
                </div>
              </div>
            </Row>
            <Row>
              <div className='col-sm-12'>
                <LabelNota>* Doble click en la fila para seleccionar la Devolución Electrónica.</LabelNota>
              </div>
            </Row>
          </ContenedorModal>
        </ModalResponsive>
        <DocumentosGeneradosPorImprimir
          tipoComprob={'DEV'}
          isVisibleCompGenPorImp={this.state.isVisibleCompGenPorImp}
          tituloDocPorImp='Devoluciones generadas por imprimir'          
          onClose = {()=>{this.setState({isVisibleCompGenPorImp: false})}}
        />
      </div>
    );
  }  
}

const mapStateToProps = state =>{
  return {  isVisibleLoading: state.ui.isVisibleLoading,           
            permiso: state.sesion.valoresSesionForm.Permiso,
            idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
            permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
            diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias,
            devolucionElectSel: state.ventas.devolucionElectronSel, facturasPend: state.ventas.facturas,
            puntoFacturacionSel: state.ventas.ptoFacturacionSel,
            devolElectronicas: state.ventas.devolElectronicas
  };
};

const mapDispatchToProps = ((dispatch) => {  
  return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm,
                              cargar_DevolucionElectronica, cambiar_VisualizacionLoading,
                              cargar_DevolucionesElectronicas,
                              setDocumentosPorImprimir }, dispatch)
});

export default connect (mapStateToProps, mapDispatchToProps)(FormVen05);